import ng from "angular";
import { IdSvrAuthService } from "../../auth/idSrvAuthService";
import { Gen } from "@topline/services/api";

class ProductOwnersComponentController {
    static $inject = ["$scope", IdSvrAuthService.componentName];

    public canEdit: boolean;
    public selectedBudgetVersion?: Gen.BudgetVersionDTO;

    constructor(
        private $scope: ng.IScope,
        private authService: IdSvrAuthService,
        private budgetVersions: Gen.BudgetVersionDTO[]
    ) {}

    $onInit(): void {
        this.authService.hasPermissionAsync("ManageProductOwners").then(result => {
            this.canEdit = result;
        });

        this.selectedBudgetVersion = _.chain(this.budgetVersions)
            .filter(v => v.isEditable)
            .first()
            .value();
    }
}

export class ProductOwnersComponent implements ng.IComponentOptions {
    static componentName = "productOwners";
    bindings = {
        budgetVersions: "<"
    };
    controller = ProductOwnersComponentController;
    template = require("./productOwners.component.html");
}

angular.module("topline.modules").component(ProductOwnersComponent.componentName, new ProductOwnersComponent());
